/**
 * Result type for operations that may fail.
 *
 * Discriminated union representing success (with value) or failure (with error).
 * Alternative to throwing exceptions.
 *
 * @example
 * ```ts
 * const success: Maybe<number> = { value: 42, error: undefined }
 * const failure: Maybe<number> = { value: undefined, error: new Error("failed") }
 * ```
 */
export type Maybe<T> =
  | {
      value: T
      error: undefined
    }
  | {
      value: undefined
      error: Error
    }
